<template>
  <div v-if="row.repeatId == null && isQcOperate">
    <div v-if="!row.canEdit">
      <div style="word-break: break-word" @click.right.prevent="handleRightClick">
        <rich-text :jsonText="row.peTextShow" readonly />
      </div>
    </div>
    <div v-else>
      <div
        class="m-b-10 edit_box p-r"
        :class="{ 'digit-error': row.hasDigitError }"
        @click.right.prevent="handleRightClick"
      >
        <rich-text
          ref="richtext"
          :id="row.id"
          :pId="row.id"
          :key="row.peTextShow"
          :hasToolbar="row.showTtoolbar"
          :jsonText="row.peTextShow"
          :errors="row.errorData"
          :readonly="
            !(
              (qcTaskId == row.qcTaskId ||
                qcTaskId == row.qcTaskIdAssist ||
                userInfo.staffId == row.qcId) &&
              row.qcStatus >= 1
            )
          "
          @focus="focusText"
          @blur="blurText"
          @change="imitateInput"
        >
          <el-popover placement="top" width="400" trigger="click">
            <p class="f-s-12 m-b-5 c-warning">
              例句仅供参考，请勿直接作为翻译结果
            </p>
            <ul class="exampleBox">
              <li
                class="f-s-12 m-b-10"
                v-for="(item, index) in exampleList"
                :key="index"
              >
                <p class="c-999">参考例句{{ index + 1 }}</p>
                <p class="m-tb-5">原文：{{ item.srcTxt }}</p>
                <p class="c-success">译文：{{ item.qcTxt }}</p>
              </li>
            </ul>
            <i
              slot="reference"
              v-show="row.hasExample"
              class="iconfont icon-lie p-a c-309F80 c-p"
              @click="getExample(row)"
            ></i>
          </el-popover>
          <el-tooltip
            class="item"
            effect="dark"
            content="一键还原为机翻译文"
            placement="top-start"
          >
            <i
              v-show="index == focusIndex"
              class="iconfont icon-a-yj-icon1 p-a c-blue c-p f-s-18"
              @click="resetPeText"
            ></i>
          </el-tooltip>
        </rich-text>
      </div>
      <div v-if="row.showQcTextUpdate">
        <el-button
          type="warning"
          size="small"
          round
          :disabled="row.isDisabled == null ? true : row.isDisabled"
          @click.stop="submitQcUpdateText(type, index, row, 2)"
        >
          微小错误
        </el-button>
        <el-button
          type="danger"
          size="small"
          round
          :disabled="row.isDisabled == null ? true : row.isDisabled"
          @click.stop="submitQcUpdateText(type, index, row, 3)"
        >
          较严重错误
        </el-button>
      </div>
      <el-button
        type="primary"
        v-if="row.showQcTextUpdateOk"
        size="small"
        round
        :disabled="
          row.isDisabled == null && row.peTextShow != null
            ? true
            : row.isDisabled
        "
        @click.stop="submitQcUpdateText(type, index, row, '')"
      >
        确定
      </el-button>
      <section v-if="row.showQcTextUpdateMtOut">
        <div ref="errTags" class="errorTag p-r" v-if="index == focusIndex">
          <ul class="d-f f-w justify-s">
            <li
              :class="[
                row.isDisabled || row.isDisabled == null ? 'disabledTag' : '',
              ]"
              v-for="item in errTagList"
              :key="item.configKey"
              @click="submitQcUpdateText(type, index, row, item.configKey)"
            >
              {{ item.configValue }}
              <i
                v-if="row.qcResult == item.configKey"
                class="el-icon-success p-a"
              ></i>
            </li>
          </ul>
          <el-popover placement="bottom" width="400" trigger="hover">
            <div class="f-s-12 c-999">
              <div
                class="l-h-20"
                v-for="(item, index) in errTagList"
                :key="index"
                v-show="item.remark"
              >
                - {{ item.configValue }}：{{ item.remark }}
              </div>
            </div>
            <i class="el-icon-question p-a errTagInfo" slot="reference"></i>
          </el-popover>
        </div>
      </section>
    </div>
  </div>
  <div v-else>
    <span style="word-break: break-word">
      <rich-text
        :jsonText="
          row.qcText == null || row.qcText === '' ? row.peText : row.qcText
        "
        readonly
      />
    </span>
  </div>
</template>

<script>
import { getSentExampleList } from '@/api/qc/qcflow';
import RichText, { datelToHtml, htmlToDatel } from '@/components/rich-text';
export default {
  name: 'TranslatedTextColumn',
  components: {
    RichText,
  },
  props: {
    row: {
      type: Object,
      default: {},
    },
    currentRow: {
      type: Object,
      default: {},
    },
    // 当前行的索引
    index: {
      type: Number,
    },
    focusIndex: {
      type: Number,
    },
    isQcOperate: {
      type: Boolean,
    },
    qcTaskId: {
      type: Number,
    },
    userInfo: {
      type: Object,
      default: {},
    },
    errorData: {
      type: Array,
      default: [],
    },
    errTagList: {
      type: Array,
      default: [],
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      exampleList: [],
    };
  },
  methods: {
    handleRightClick(e) {
      this.$emit('open-quick-actions', 'peTarget', this.row, e);
    },
    imitateInput(e, jsonText) {
      this.$emit('imitate-input', e, jsonText, this.row, this.index, this.type);
    },
    blurText(e, jsonText, textAll) {
      this.$emit(
        'blur-text',
        e,
        jsonText,
        textAll,
        this.row,
        this.index,
        this.type,
      );
    },
    focusText(e, jsonText) {
      this.$emit('focus-text', e, jsonText, this.row, this.index);
    },
    resetPeText() {
      // 点击一键还原机翻会失焦，因为触发了富文本更新，所以加了setTimeout
      setTimeout(() => {
        this.$emit('reset-peText', this.row, this.index);
      });
    },
    submitQcUpdateText(...args) {
      this.$emit('submit-qc-update-text', ...args);
    },
    getExample(row) {
      getSentExampleList({
        sentId: row.id,
      }).then((res) => {
        this.exampleList = res.data?.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.exampleBox {
  max-height: 260px;
  overflow-y: scroll;
  li {
    p {
      overflow-wrap: break-word;
      word-break: normal;
      word-wrap: break-word;
      text-align: left;
    }
  }
}
</style>
